'use client'
import Image from 'next/image'
import type { FC } from 'react'
import React, { useMemo } from 'react'
import sanitizeHtml from 'sanitize-html'
import noLocationImage from './assets/no-location.svg'
import styles from './LocationBanner.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { ArrowForwardIcon, BaseInput, InputSize, LocationMarkerIcon } from '@/tools/ui'

interface Props {
  isStorePage: boolean
  cityName: string
  className?: string
}

export const LocationBanner: FC<Props> = ({ isStorePage, cityName }) => {
  const { t } = useLocalisation()
  const cityText = useMemo(() => {
    if (!cityName) {
      return ''
    }
    const rawHtml = t('address-banner.text-store-wall', { city: cityName })
    return sanitizeHtml(rawHtml)
  }, [cityName, t])

  return (
    <div className={styles.locationBanner}>
      <div className={styles.wrapper}>
        <div className={styles.leftContent}>
          <Image alt="" className={styles.image} src={noLocationImage} />
          {isStorePage ? (
            <div className={styles.text}>
              <b>{t('address-banner.text-store')}</b>
            </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: cityText }} className={styles.text} />
          )}
        </div>
        <div className={styles.rightContent}>
          <BaseInput
            leadingIcon={LocationMarkerIcon}
            placeholder={t('landing.address-picker')}
            readonly={true}
            size={InputSize.medium}
            trailingIcon={ArrowForwardIcon}
          />
        </div>
      </div>
    </div>
  )
}
